import { call, put } from 'redux-saga/effects';
import { showToastMessage } from '../../services/notification';

import api, { makeOptions } from '../../services/api';
import EquipamentoFilmagemListActions from '../ducks/equipamento-filmagem-list';

const dataLocal = JSON.parse(localStorage.getItem('persist:Spcine'));
// const getAuthData = (state) => state.auth.data;

export function* fetch() {
  try {
    // const authData = yield select(getAuthData);
    const url = `/ld-equipamento-filmagem`;
    const { data: responseData } = yield call(
      api.get,
      url,
      makeOptions(dataLocal.auth.data),
    );
    const { data, ...pagination } = responseData;
    yield put(EquipamentoFilmagemListActions.success(data, pagination));
  } catch (err) {
    yield put(
      EquipamentoFilmagemListActions.failure(err.response.data.error.message),
    );
    showToastMessage({
      type: 'error',
      text: err.response.data.error.message,
    });
  }
}

export function* fetchSelect() {
  try {
    // const authData = yield select(getAuthData);
    const url = `/ld-equipamento-filmagem?paginate=false`;
    const { data: responseData } = yield call(
      api.get,
      url,
      makeOptions(dataLocal.auth.data),
    );
    const { data } = responseData;
    const list = data.map(({ uuid, name }) => ({
      value: uuid,
      label: name,
    }));

    yield put(EquipamentoFilmagemListActions.showSuccess(list));
  } catch (err) {
    yield put(
      EquipamentoFilmagemListActions.showFailure(
        err.response.data.error.message,
      ),
    );
    showToastMessage({
      type: 'error',
      text: err.response.data.error.message,
    });
  }
}
